export enum WeekOfTypeEnum {
  FIRST = 1,
  SECOND = 2,
  THIRD = 3,
  FOURTH = 4,
}
